/**
 * Country list with ISO 3166-1 alpha-2 codes and emoji flags.
 * Emoji flags are generated from Unicode regional indicator pairs,
 * so no external library is required.
 */

/** Convert an ISO-3166-1 alpha-2 code (e.g. 'AU') into a flag emoji */
export const countryCodeToFlag = (code = ''): string =>
  code
    .toUpperCase()
    .split('')
    .map(ch => String.fromCodePoint(0x1f1e6 + ch.charCodeAt(0) - 65))
    .join('');

export const COUNTRIES = [
  { id: 1, value: "US", label: "United States" },
  { id: 2, value: "CA", label: "Canada" },
  { id: 3, value: "GB", label: "United Kingdom" },
  { id: 4, value: "AD", label: "Andorra" },
  { id: 5, value: "AE", label: "United Arab Emirates" },
  { id: 6, value: "AF", label: "Afghanistan" },
  { id: 7, value: "AG", label: "Antigua and Barbuda" },
  { id: 8, value: "AI", label: "Anguilla" },
  { id: 9, value: "AL", label: "Albania" },
  { id: 10, value: "AM", label: "Armenia" },
  { id: 11, value: "AO", label: "Angola"},
  { id: 12, value: "AQ", label: "Antarctica"},
  { id: 13, value: "AR", label: "Argentina" },
  { id: 14, value: "AS", label: "American Samoa" },
  { id: 15, value: "AT", label: "Austria" },
  { id: 16, value: "AU", label: "Australia" },
  { id: 17, value: "AW", label: "Aruba" },
  { id: 18, value: "AX", label: "Åland Islands" },
  { id: 19, value: "AZ", label: "Azerbaijan" },
  { id: 20, value: "BA", label: "Bosnia and Herzegovina" },
  { id: 21, value: "BB", label: "Barbados" },
  { id: 22, value: "BD", label: "Bangladesh" },
  { id: 23, value: "BE", label: "Belgium" },
  { id: 24, value: "BF", label: "Burkina Faso" },
  { id: 25, value: "BG", label: "Bulgaria" },
  { id: 26, value: "BH", label: "Bahrain" },
  { id: 27, value: "BI", label: "Burundi" },
  { id: 28, value: "BJ", label: "Benin" },
  { id: 29, value: "BL", label: "Saint Barthélemy" },
  { id: 30, value: "BM", label: "Bermuda" },
  { id: 31, value: "BN", label: "Brunei Darussalam" },
  { id: 32, value: "BO", label: "Bolivia" },
  { id: 33, value: "BQ", label: "Caribbean Netherlands " },
  { id: 34, value: "BR", label: "Brazil" },
  { id: 35, value: "BS", label: "Bahamas" },
  { id: 36, value: "BT", label: "Bhutan" },
  { id: 37, value: "BV", label: "Bouvet Island" },
  { id: 38, value: "BW", label: "Botswana" },
  { id: 39, value: "BY", label: "Belarus" },
  { id: 40, value: "BZ", label: "Belize" },
  { id: 41, value: "CC", label: "Cocos (Keeling) Islands" },
  { id: 42, value: "CD", label: "Congo, Democratic Republic of" },
  { id: 43, value: "CF", label: "Central African Republic" },
  { id: 44, value: "CG", label: "Congo" },
  { id: 45, value: "CH", label: "Switzerland" },
  { id: 46, value: "CI", label: "Côte D’Ivoire" },
  { id: 47, value: "CK", label: "Cook Islands" },
  { id: 48, value: "CL", label: "Chile" },
  { id: 49, value: "CM", label: "Cameroon" },
  { id: 50, value: "CN", label: "China" },
  { id: 51, value: "CO", label: "Colombia" },
  { id: 52, value: "CR", label: "Costa Rica" },
  { id: 53, value: "CU", label: "Cuba" },
  { id: 54, value: "CV", label: "Cape Verde" },
  { id: 55, value: "CW", label: "Curaçao" },
  { id: 56, value: "CX", label: "Christmas Island" },
  { id: 57, value: "CY", label: "Cyprus" },
  { id: 58, value: "CZ", label: "Czech Republic" },
  { id: 59, value: "DE", label: "Germany" },
  { id: 60, value: "DJ", label: "Djibouti" },
  { id: 61, value: "DK", label: "Denmark" },
  { id: 62, value: "DM", label: "Dominica" },
  { id: 63, value: "DO", label: "Dominican Republic" },
  { id: 64, value: "DZ", label: "Algeria" },
  { id: 65, value: "EC", label: "Ecuador" },
  { id: 66, value: "EE", label: "Estonia" },
  { id: 67, value: "EG", label: "Egypt" },
  { id: 68, value: "EH", label: "Western Sahara" },
  { id: 69, value: "ER", label: "Eritrea" },
  { id: 70, value: "ES", label: "Spain" },
  { id: 71, value: "ET", label: "Ethiopia" },
  { id: 72, value: "FI", label: "Finland" },
  { id: 73, value: "FJ", label: "Fiji" },
  { id: 74, value: "FK", label: "Falkland Islands" },
  { id: 75, value: "FM", label: "Micronesia, Federated States of" },
  { id: 76, value: "FO", label: "Faroe Islands" },
  { id: 77, value: "FR", label: "France" },
  { id: 78, value: "GA", label: "Gabon" },
  { id: 80, value: "GD", label: "Grenada" },
  { id: 81, value: "GE", label: "Georgia" },
  { id: 82, value: "GF", label: "French Guiana" },
  { id: 83, value: "GG", label: "Guernsey" },
  { id: 84, value: "GH", label: "Ghana" },
  { id: 85, value: "GI", label: "Gibraltar" },
  { id: 86, value: "GL", label: "Greenland" },
  { id: 87, value: "GM", label: "Gambia" },
  { id: 88, value: "GN", label: "Guinea" },
  { id: 89, value: "GP", label: "Guadeloupe" },
  { id: 90, value: "GQ", label: "Equatorial Guinea" },
  { id: 91, value: "GR", label: "Greece" },
  { id: 92, value: "GS", label: "South Georgia and the South Sandwich Islands" },
  { id: 93, value: "GT", label: "Guatemala" },
  { id: 94, value: "GU", label: "Guam" },
  { id: 95, value: "GW", label: "Guinea-Bissau" },
  { id: 96, value: "GY", label: "Guyana" },
  { id: 97, value: "HK", label: "Hong Kong" },
  { id: 98, value: "HM", label: "Heard and McDonald Islands" },
  { id: 99, value: "HN", label: "Honduras" },
  { id: 100, value: "HR", label: "Croatia" },
  { id: 101, value: "HT", label: "Haiti" },
  { id: 102, value: "HU", label: "Hungary" },
  { id: 103, value: "ID", label: "Indonesia" },
  { id: 104, value: "IE", label: "Ireland" },
  { id: 105, value: "IL", label: "Israel"},
  { id: 106, value: "IM", label: "Isle of Man" },
  { id: 107, value: "IN", label: "India"},
  { id: 108, value: "IO", label: "British Indian Ocean Territory" },
  { id: 109, value: "IQ", label: "Iraq"},
  { id: 110, value: "IR", label: "Iran" },
  { id: 111, value: "IS", label: "Iceland" },
  { id: 112, value: "IT", label: "Italy" },
  { id: 113, value: "JE", label: "Jersey" },
  { id: 114, value: "JM", label: "Jamaica" },
  { id: 115, value: "JO", label: "Jordan" },
  { id: 116, value: "JP", label: "Japan" },
  { id: 117, value: "KE", label: "Kenya" },
  { id: 118, value: "KG", label: "Kyrgyzstan" },
  { id: 119, value: "KH", label: "Cambodia" },
  { id: 120, value: "KI", label: "Kiribati" },
  { id: 121, value: "KM", label: "Comoros" },
  { id: 122, value: "KN", label: "Saint Kitts and Nevis" },
  { id: 123, value: "KP", label: "North Korea" },
  { id: 124, value: "KR", label: "South Korea" },
  { id: 125, value: "KW", label: "Kuwait" },
  { id: 126, value: "KY", label: "Cayman Islands" },
  { id: 127, value: "KZ", label: "Kazakhstan" },
  { id: 128, value: "LA", label: "Lao People’s Democratic Republic" },
  { id: 129, value: "LB", label: "Lebanon" },
  { id: 130, value: "LC", label: "Saint Lucia" },
  { id: 131, value: "LI", label: "Liechtenstein" },
  { id: 132, value: "LK", label: "Sri Lanka" },
  { id: 133, value: "LR", label: "Liberia" },
  { id: 134, value: "LS", label: "Lesotho" },
  { id: 135, value: "LT", label: "Lithuania" },
  { id: 136, value: "LU", label: "Luxembourg" },
  { id: 137, value: "LV", label: "Latvia" },
  { id: 138, value: "LY", label: "Libya" },
  { id: 139, value: "MA", label: "Morocco" },
  { id: 140, value: "MC", label: "Monaco" },
  { id: 141, value: "MD", label: "Moldova" },
  { id: 142, value: "ME", label: "Montenegro" },
  { id: 143, value: "MF", label: "Saint-Martin (France)" },
  { id: 144, value: "MG", label: "Madagascar" },
  { id: 145, value: "MH", label: "Marshall Islands" },
  { id: 146, value: "MK", label: "Macedonia" },
  { id: 147, value: "ML", label: "Mali" },
  { id: 148, value: "MM", label: "Myanmar" },
  { id: 149, value: "MN", label: "Mongolia" },
  { id: 150, value: "MO", label: "Macau" },
  { id: 151, value: "MP", label: "Northern Mariana Islands" },
  { id: 152, value: "MQ", label: "Martinique" },
  { id: 153, value: "MR", label: "Mauritania" },
  { id: 154, value: "MS", label: "Montserrat" },
  { id: 155, value: "MT", label: "Malta" },
  { id: 156, value: "MU", label: "Mauritius" },
  { id: 157, value: "MV", label: "Maldives" },
  { id: 158, value: "MW", label: "Malawi" },
  { id: 159, value: "MX", label: "Mexico" },
  { id: 160, value: "MY", label: "Malaysia" },
  { id: 161, value: "MZ", label: "Mozambique" },
  { id: 162, value: "NA", label: "Namibia" },
  { id: 163, value: "NC", label: "New Caledonia" },
  { id: 164, value: "NE", label: "Niger" },
  { id: 165, value: "NF", label: "Norfolk Island" },
  { id: 166, value: "NG", label: "Nigeria" },
  { id: 167, value: "NI", label: "Nicaragua" },
  { id: 168, value: "NL", label: "The Netherlands" },
  { id: 169, value: "NO", label: "Norway" },
  { id: 170, value: "NP", label: "Nepal" },
  { id: 171, value: "NR", label: "Nauru" },
  { id: 172, value: "NU", label: "Niue" },
  { id: 173, value: "NZ", label: "New Zealand" },
  { id: 174, value: "OM", label: "Oman" },
  { id: 175, value: "PA", label: "Panama" },
  { id: 176, value: "PE", label: "Peru" },
  { id: 177, value: "PF", label: "French Polynesia" },
  { id: 178, value: "PG", label: "Papua New Guinea" },
  { id: 179, value: "PH", label: "Philippines" },
  { id: 180, value: "PK", label: "Pakistan" },
  { id: 181, value: "PL", label: "Poland" },
  { id: 182, value: "PM", label: "St. Pierre and Miquelon" },
  { id: 183, value: "PN", label: "Pitcairn" },
  { id: 184, value: "PR", label: "Puerto Rico" },
  { id: 185, value: "PS", label: "Palestinian Territory, Occupied" },
  { id: 186, value: "PT", label: "Portugal" },
  { id: 187, value: "PW", label: "Palau" },
  { id: 188, value: "PY", label: "Paraguay" },
  { id: 189, value: "QA", label: "Qatar" },
  { id: 190, value: "RE", label: "Reunion" },
  { id: 191, value: "RO", label: "Romania" },
  { id: 192, value: "RS", label: "Serbia" },
  { id: 193, value: "RU", label: "Russian Federation" },
  { id: 194, value: "RW", label: "Rwanda" },
  { id: 195, value: "SA", label: "Saudi Arabia" },
  { id: 196, value: "SB", label: "Solomon Islands" },
  { id: 197, value: "SC", label: "Seychelles" },
  { id: 198, value: "SD", label: "Sudan" },
  { id: 199, value: "SE", label: "Sweden" },
  { id: 200, value: "SG", label: "Singapore" },
  { id: 201, value: "SH", label: "Saint Helena" },
  { id: 202, value: "SI", label: "Slovenia" },
  { id: 203, value: "SJ", label: "Svalbard and Jan Mayen Islands" },
  { id: 204, value: "SK", label: "Slovakia (Slovak Republic)" },
  { id: 205, value: "SL", label: "Sierra Leone" },
  { id: 206, value: "SM", label: "San Marino" },
  { id: 207, value: "SN", label: "Senegal" },
  { id: 208, value: "SO", label: "Somalia" },
  { id: 209, value: "SR", label: "Suriname" },
  { id: 210, value: "SS", label: "South Sudan" },
  { id: 211, value: "ST", label: "Sao Tome and Principe" },
  { id: 212, value: "SV", label: "El Salvador" },
  { id: 213, value: "SX", label: "Saint-Martin (Pays-Bas)" },
  { id: 214, value: "SY", label: "Syria" },
  { id: 215, value: "SZ", label: "Swaziland" },
  { id: 216, value: "TC", label: "Turks and Caicos Islands" },
  { id: 217, value: "TD", label: "Chad" },
  { id: 218, value: "TF", label: "French Southern Territories" },
  { id: 219, value: "TG", label: "Togo" },
  { id: 220, value: "TH", label: "Thailand" },
  { id: 221, value: "TJ", label: "Tajikistan" },
  { id: 222, value: "TK", label: "Tokelau" },
  { id: 223, value: "TL", label: "Timor-Leste" },
  { id: 224, value: "TM", label: "Turkmenistan" },
  { id: 225, value: "TN", label: "Tunisia" },
  { id: 226, value: "TO", label: "Tonga" },
  { id: 227, value: "TR", label: "Turkey"},
  { id: 228, value: "TT", label: "Trinidad and Tobago" },
  { id: 229, value: "TV", label: "Tuvalu" },
  { id: 230, value: "TW", label: "Taiwan" },
  { id: 231, value: "TZ", label: "Tanzania" },
  { id: 232, value: "UA", label: "Ukraine" },
  { id: 233, value: "UG", label: "Uganda" },
  { id: 234, value: "UM", label: "United States Minor Outlying Islands" },
  { id: 235, value: "UY", label: "Uruguay" },
  { id: 236, value: "UZ", label: "Uzbekistan" },
  { id: 237, value: "VA", label: "Vatican" },
  { id: 238, value: "VC", label: "Saint Vincent and the Grenadines" },
  { id: 239, value: "VE", label: "Venezuela" },
  { id: 240, value: "VG", label: "Virgin Islands (British)" },
  { id: 241, value: "VI", label: "Virgin Islands (U.S.)" },
  { id: 242, value: "VN", label: "Vietnam" },
  { id: 243, value: "VU", label: "Vanuatu" },
  { id: 244, value: "WF", label: "Wallis and Futuna Islands" },
  { id: 245, value: "WS", label: "Samoa" },
  { id: 246, value: "YE", label: "Yemen" },
  { id: 247, value: "YT", label: "Mayotte" },
  { id: 248, value: "ZA", label: "South Africa" },
  { id: 249, value: "ZM", label: "Zambia" },
  { id: 250, value: "ZW", label: "Zimbabwe" }
];
